module.exports = __webpack_public_path__ + "img/chessboard.e72e29d4.png";